import React from 'react';
import { MdArrowDownward, MdOutlineCheckCircleOutline, MdOutlineQrCode, MdOutlineShoppingCart } from 'react-icons/md';
import { Step, Description, StepArrow, Container } from './styles';
import useTranslate from '@src/i18n/useTranslate';

export const Steps = () => {
  const { i18n } = useTranslate();

  const steps = [
    {
      icon: <MdOutlineShoppingCart color='#333333' size={24} />,
      description: i18n('direct_link_pix_form_steps_step_1'),
    },
    {
      icon: <MdOutlineQrCode color='#333333' size={24} />,
      description: i18n('direct_link_pix_form_steps_step_2'),
    },
    {
      icon: <MdOutlineCheckCircleOutline color='#333333' size={24} />,
      description: i18n('direct_link_pix_form_steps_step_3'),
    },
  ];

  return (
    <Container>
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          {index ? (
            <StepArrow>
              <MdArrowDownward size={24} />
            </StepArrow>
          ) : null}

          <Step>
            {step.icon}
            <Description>{step.description}</Description>
          </Step>
        </React.Fragment>
      ))}
    </Container>
  );
};

export default Steps;
